import BaseModelAPI from '../BaseModelAPI';

export default class ReportTracingAbilityDetail extends BaseModelAPI {
	static entity = 'newreport2135';
	static entityName = 'reporttracingabilitydetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.filterControlCardId = '';
			this.tempId = 0;
			this.materialSource = '';
			this.partNumber = '';
			this.controlCardDestination = '';
			this.lotNo = '';
			this.wopNumber = '';
			this.productionDate = '';
			this.finishProductionDate = '';
			this.machine = '';
			this.operatorUser = '';
			this.shift = '';
			this.qtyBefore = '';
			this.qtyAfter = 0;
			this.qtyTaken = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}